import {
  SimulatorNavigation,
  type SimulatorArea,
  type SimulatorField,
} from '@vedalib/editor/lib/elements'

import { NOOP } from 'constants/commonConstans'

import Area from './Area'
import InputField from './InputField'
import Item from './Item'
import Navigation from './Navigation/Navigation'
import type { ILabeledGraphicProps } from './SimulatorContext'
import SimulatorContext from './SimulatorContext'
import * as s from './SimulatorElement.module.scss'
import { getViewedCount } from './helper'
import type { SimulatorElementProps } from './simulatorTypes'

type SimulatorPdfViewProps = Pick<
  Parameters<SimulatorElementProps>[0],
  'element' | 'styles'
> & {
  contextValue: ILabeledGraphicProps
  selectedAreaId: string | null
  viewedItems: Record<string, boolean>
}

const SimulatorPdfView: React.FC<SimulatorPdfViewProps> = ({
  element,
  styles,
  contextValue,
  selectedAreaId,
  viewedItems,
}) => {
  const { value } = element

  return (
    <SimulatorContext.Provider value={contextValue}>
      {value.items.map((item, index) => (
        <>
          <div className={s.root} key={item.value} style={{ height: styles.shell?.minHeight }}>
            <div
              className={s.img}
              key={item.value}
              style={{ minHeight: styles.shell?.minHeight || 400 }}
            >
              <Item
                image={item?.image}
                key={item?.value}
                overlay={item?.overlay}
                showAnimation={false}
              />
              {item.areas?.map((area: SimulatorArea) => (
                <Area
                  area={area}
                  currentItemId={item.value}
                  elementId={element.id}
                  key={area.id}
                  onMouseDown={NOOP}
                  selected={selectedAreaId === area?.id}
                />
              ))}
              {item.fields?.map((field: SimulatorField) => (
                <InputField
                  field={field}
                  key={field.id}
                  onMouseDown={NOOP}
                  onSelect={NOOP}
                  onUpdateField={NOOP}
                  selected={false}
                />
              ))}
            </div>
          </div>
          {value.navigation !== SimulatorNavigation.NONE && index === 0 && (
            <Navigation viewed={getViewedCount(viewedItems)} />
          )}
        </>
      ))}
    </SimulatorContext.Provider>
  )
}

export default SimulatorPdfView
